import { FunctionComponent } from 'react';

type TableActionsProps = {
  children?: React.ReactNode;
};

const TableActions: FunctionComponent<TableActionsProps> = ({ children }) => {
  return <div className="h-full">{children}</div>;
};

export default TableActions;
